import { MusicStateToggleButtonWrapper as MusicStateToggleButton } from '../background-action/MusicStateToggleButtonWrapper';
import { HorizontalVibes } from './HorizontalVibes';
import { KeyboardWrapper as Keyboard } from './KeyboardWrapper';
import type { VibesComponentProps } from './types';

export function HorizontalVibesWrapper(props: VibesComponentProps) {
  return (
    <HorizontalVibes {...props} keyboardComponent={Keyboard} musicStateToggleButtonComponent={MusicStateToggleButton} />
  );
}
